import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import {
  type Control,
  Controller,
  type FieldValues,
  type Path,
} from 'react-hook-form';

interface Props<T extends Record<string, unknown>> {
  control: Control<T, unknown, T>;
  name: Path<T>;
}

export const HideTerminatedAgentsFilter = <T extends FieldValues>({
  control,
  name,
}: Props<T>) => {
  return (
    <Box>
      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        Filter Settings
      </Typography>
      <Controller
        name={name}
        control={control}
        render={({ field: { value, onChange } }) => (
          <FormControlLabel
            control={
              <Checkbox
                checked={value}
                onChange={(e) => onChange(e.target.checked)}
              />
            }
            label="Hide Terminated Agents"
          />
        )}
      />
    </Box>
  );
};
